import React from 'react';
export function ProofSection() {
  return <section className="py-24 px-4 bg-warm-bg" data-id="element-145">
      <div className="max-w-3xl mx-auto text-center" data-id="element-146">
        <h2 className="text-3xl md:text-5xl font-black text-warm-dark mb-10 leading-tight" data-id="element-147">
          Resultados Visibles en Solo 7 Días
        </h2>

        <div className="text-lg md:text-xl text-warm-mid leading-relaxed space-y-6" data-id="element-148">
          <p data-id="element-149">
            Verás un cambio en la forma en que tu hijo reacciona ante el error.
            No dejará de fallar (porque el error es parte del juego), pero{' '}
            <strong className="text-warm-dark" data-id="element-150">
              dejará de "romperse" emocionalmente
            </strong>{' '}
            cuando suceda.
          </p>
          <p className="text-warm-dark font-medium" data-id="element-151">
            Notarás que recupera la sonrisa y la agresividad deportiva mucho más
            rápido tras un fallo.
          </p>
        </div>
      </div>
    </section>;
}